var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFaqs3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 62,
    r: 61,
    stroke: "#339999",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.8499 37.4581C63.1798 37.1562 62.452 37 61.7155 37C60.979 37 60.2512 37.1562 59.5811 37.4581L37.543 47.3633C37.0866 47.562 36.6987 47.8875 36.4263 48.3001C36.1539 48.7127 36.0089 49.1947 36.0089 49.6872C36.0089 50.1798 36.1539 50.6617 36.4263 51.0743C36.6987 51.4869 37.0866 51.8124 37.543 52.0111L59.6068 61.9417C60.2769 62.2436 61.0048 62.3998 61.7412 62.3998C62.4777 62.3998 63.2056 62.2436 63.8756 61.9417L85.9395 52.0365C86.3958 51.8378 86.7838 51.5123 87.0562 51.0997C87.3285 50.6871 87.4735 50.2052 87.4735 49.7126C87.4735 49.2201 87.3285 48.7381 87.0562 48.3255C86.7838 47.9129 86.3958 47.5874 85.9395 47.3887L63.8499 37.4581Z",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36 62.3989C35.9988 62.8847 36.1387 63.3606 36.403 63.7703C36.6674 64.1799 37.0451 64.5061 37.4915 64.7101L59.6068 74.6408C60.2734 74.9389 60.9966 75.0931 61.7283 75.0931C62.46 75.0931 63.1833 74.9389 63.8499 74.6408L85.9138 64.7355C86.3689 64.5335 86.7548 64.205 87.0242 63.7901C87.2936 63.3752 87.4349 62.8918 87.431 62.3989",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 75.0979C35.9988 75.5837 36.1387 76.0596 36.403 76.4693C36.6674 76.8789 37.0451 77.2051 37.4915 77.4091L59.6068 87.3397C60.2734 87.6378 60.9966 87.792 61.7283 87.792C62.46 87.792 63.1833 87.6378 63.8499 87.3397L85.9138 77.4345C86.3689 77.2324 86.7548 76.9039 87.0242 76.489C87.2936 76.0741 87.4349 75.5908 87.431 75.0979",
    stroke: "#339999",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaqs3);
export default __webpack_public_path__ + "static/media/IconFaqs3.5c7c3fbf058b2464ed40cc846a11739d.svg";
export { ForwardRef as ReactComponent };